import ApiClient from './ApiClient';

export default class ComplexApi extends ApiClient {
  fetchPremiumComplex (complexType, params) {
    return this.axios()
      .get(`${this.prefix}${complexType}/widget`, {params})
      .then(res => res.data);
  }
}



// WEBPACK FOOTER //
// ./src/api/Complex.js